import {useContext, useRef, useState} from "react";
import UserContext from "../../../store/userContext";
import {Link} from "react-router-dom";

import c from "./LoginBox.module.scss";
import LoginGoogle from "./LoginGoogle";
import ClickToExpand from "../ClickToExpand";
import LoginFacebook from "./LoginFacebook";
import MailIcon from "../../../svg/MailIcon";


function Loginbox({propUsername, propMessage, sendToRefreshBool, removeTitleSection}){
	if(!propUsername)
		propUsername = "";


	const [username, setUsername] = useState(propUsername);
	const [password, setPassword] = useState('');
	const [errorMessage, setErrorMessage] = useState('');

	const [isLoading, setIsLoading] = useState(false);
	const [isSuccessful, setIsSuccesful] = useState(false);

	const usernameInput = useRef();
	const passwordInput = useRef();

	const user = useContext(UserContext);

	function isFacebookAppFunc() {
		return /FBAV|FBAN/.test(navigator.userAgent);
	}
	const [isFacebookApp, setIsFacebookApp] = useState(isFacebookAppFunc());
	const openInBrowser = () => {
		const url = window.location.href;

		// For Android: Use intent:// to open the link in an external browser
		if (/android/i.test(navigator.userAgent)) {
			window.location.href = `intent://${url.replace(/^https?:\/\//, '')}#Intent;scheme=https;package=com.android.chrome;end;`;
		}
		// For iOS: Use window.open with _blank to open in Safari
		else {
			window.open(url, "_blank");
		}
	};

	let facebookEnabled = false;
	// make facebook enabled if fb=true in url parameters
	if(window.location.search.includes('fb=true'))
		facebookEnabled = true;

	function loginUser(event){
		event.preventDefault();
		setIsLoading(true);
		user.login(usernameInput.current.value, passwordInput.current.value, (success, resObj)=>{
			setIsLoading(false);

			if (!success && resObj?.message)
				return setErrorMessage(resObj.message);
			if(!success)
				return setErrorMessage('Feil brukernavn eller passord');
			if (success)
				setIsSuccesful(true);

			if(sendToRefreshBool)
				window.location = window.location;
		});
	}

	if (isFacebookApp)return <section className={[c.centered, c.loginBox].join(' ')}>
		<h3>Facebook appen støtter ikke innlogging.</h3>
		<p>For å fortsette, besøk b-v.no via en nettleser</p>
		<p>Trykk på knappen med tre prikker (...) i hjørnet av skjermen og velg åpne i nettleser </p>
	</section>

	return(
		<section className={[c.centered, c.loginBox].join(' ')}>
			{!removeTitleSection&&<>
				<h1>Logg inn</h1>
				<h4>eller registrer med...</h4>
			</>}

			{propMessage && <div style={{marginBottom: '10px',fontFamily:'var(--font1)'}}>{propMessage}</div>}
			<div className={c.loginOptions}>
				<ClickToExpand buttonText={<><MailIcon stroke={'gray'}/>Fortsett med E-post</>}
							   buttonClassName={c.loginOption}>
					<div className={c.registerAsk}>Har du ikke bruker? <Link to={"/registrer"}>Opprett bruker</Link>
					</div>
					<form onSubmit={loginUser}>
						<input type="email" placeholder={"E-post adresse"} value={username}
							   onChange={e => setUsername(e.target.value)} ref={usernameInput} required={true}
							   disabled={isLoading}></input>
						<br/><

						input type="password" placeholder={"Passord"} value={password}
							  onChange={e => setPassword(e.target.value)} ref={passwordInput} required={true}
							  disabled={isLoading}/>
						{errorMessage && <div style={{color: "red"}}>{errorMessage}</div>}
						<br/>

						<button id={c.loginSubmit} type="submit" disabled={isLoading}
								className={[c.loginSubmit, isLoading ? 'animationShimmerBlack' : '', isSuccessful ? 'animationSuccess animationShimmerOnce' : ''].join(' ')
								}>Logg inn
						</button>

						<br/>
						<Link to={'/glemtpassord'}
							  style={{margin: '4px auto', display: 'inline-block'}}
						>Glemt Passord</Link>
					</form>
				</ClickToExpand>
				<hr className={c.divider}/>
				{facebookEnabled&&<LoginFacebook/>}
				<LoginGoogle sendToRefreshBool={sendToRefreshBool}/>
			</div>

		</section>
	)
}

export default Loginbox;